import React from 'react';
import { ConfirmDialog } from '../../../../components/confirm-dialog';

export interface IUpdateFutureLessonsDialogProps {
  isOpen: boolean;
  isLoading: boolean;
  onUpdateLessonsClick: () => void;
  onKeepLessonsClick: () => void;
}

export function UpdateFutureLessonsDialog({ isOpen, isLoading, onUpdateLessonsClick, onKeepLessonsClick }: IUpdateFutureLessonsDialogProps) {
  return (
    <ConfirmDialog
      title="Skal fremtidige lektioner opdateres?"
      type="question"
      open={isOpen}
      onConfirmClick={onUpdateLessonsClick}
      onCancelClick={onKeepLessonsClick}
      confirmButtonText="Ja, opdater fremtidige lektioner"
      cancelButtonText="Nej, opdater kun holdet"
      cancelIsPrimary
      isLoading={isLoading}
      disableBackdropClick
    >
      <p>Du har ændret holdets fremmødetjek ved lektionens start eller slutning. Skal holdets fremtidige lektioner opdateres med de nye tidspunkter?</p>
    </ConfirmDialog>
  );
}
